
const ModalDetailsContent = (props) => (
    <div className="w-1/2 pr-6 mb-6">
        <div className="font-medium text-xs">
            {props.label}
        </div>
        <div className="mt-1 text-xs">
            {props.value}
        </div>
    </div>
)

export default ModalDetailsContent
